import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/subscription-status/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const subscriptionStatus = {
  getAll: apiPathFunc(pathBase),
} as const;
